import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans fundraising / cagnottes (clés `fundraising.*`).
 *
 * Les clés vivent dans le fragment
 * `features/fundraising/i18n/fundraising.json` et seront fusionnées dans
 * `src/locales/*.json` lors du câblage final par le coordinateur : tant
 * que la fusion n'est pas faite, `TFunctionType` (dérivé de fr.json) ne
 * les connaît pas encore, d'où le cast.
 */
export const useFundraisingTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
